/**
 * Tag Assistant (Google)
 *
 * Exposes one static resource: the page-world API bundle it uses to talk to Google Tag
 * Manager on the page.
 * Manifest verified against version 26.167.2.46.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'kejbdjndbnbjgmefkgdddjlbokphdefk';
export const tagAssistant: ExtensionDefinition = {
  id: ID,
  name: 'Tag Assistant',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 3_000_000,
  notes:
    'Identifies the visitor as someone who debugs analytics tags — a strong hint that ' +
    'they are a marketer or developer rather than an ordinary visitor.',
  signals: [
    { id: 'war-tag-assistant-api', kind: 'web-accessible-resource',
      description: 'Fetch cs/ta/tag_assistant_api_bin.js — the page-world API bundle.',
      weight: 1, run: () => probeFetch(ID, 'cs/ta/tag_assistant_api_bin.js') },
  ],
};
